import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';

import { DatosCfdiFacturasService } from '../../servicios/datos-cfdi-facturas.service';
import {
  DatosCfdiFacturas, CatCfdiUsos, PersonaClientes,
  CatTipoPersonas, CatMedioPagos, DesgloseFacturas, FacturacionData,
  AuxJasper, ParametroJasper, BuscaCobros, GuardaFacturas, EnviarCorreo,
  CatCfdiTiposRelacion,
  Privilegios
} from '../../entidades/entidades';

import { CatMedioPagosService } from '../../servicios/cat-medio-pagos.service';
import { CatCfdiUsosService } from '../../servicios/cat-cfdi-usos.service';
import { PersonaClientesService } from '../../servicios/persona-clientes.service';
import { DesgloseFacturasService } from '../../servicios/desglose-facturas.service';
import { JasperService } from './../../servicios/jasper.service';
//import { GuardaFacturas, PersonaClientes } from '../../entidades/entidades';
import { BuscaPersonaClientesService } from '../../servicios/busca-persona-clientes.service';
import  {CatCfdiTiposRelacionService} from '../../servicios/cat-cfdi-tipos-relacion.service'
import { PrivilegiosService } from 'app/servicios/privilegios.service';
declare var $: any;

@Component({
  selector: 'app-cmp-facturacion',
  templateUrl: './cmp-facturacion.component.html',
  styleUrls: ['./cmp-facturacion.component.css']
})
export class CmpFacturacionComponent implements OnChanges {
  muestraMensaje = new MuestraMensaje();
  datosCfdiFacturasForm: FormGroup;
  datosClientesForm: FormGroup;
  desgloseFacturasForm: FormGroup;
  catalogosForm: FormGroup;
  mensajeForm: FormGroup;

  catMedioPagos: CatMedioPagos[] = [];
  catUsoCfdi: CatCfdiUsos[] = [];
  catTipoPersonas: CatTipoPersonas[] = [];

  DatosCobrosTable: any[] = [];

  DatosCobroTabla: BuscaCobros;

  buscaClientes = false;
  seleccion = '';
  mediopago = new CatMedioPagos();
  usoCFDI = new CatCfdiUsos();
  tipoRelacion = new CatCfdiTiposRelacion();
  personaCliente = new PersonaClientes();
  datosCFDI = new DatosCfdiFacturas;
  desgloseFactura = new DesgloseFacturas();
  facturacionData = new FacturacionData();
  guardaFacturas = new GuardaFacturas();

  private _jasperService: JasperService;

  @Input('buscaCobro') buscaCobro: BuscaCobros;

  @Input('datosCfdiFacturas') datosCfdiFacturas: DatosCfdiFacturas;
  @Output('datosCfdiFacturasOutput') datosCfdiFacturasOutput: EventEmitter<DatosCfdiFacturas>;

  @Input('personaClientes') personaClientes: PersonaClientes;
  @Output('personaClientesOutput') personaClientesOutput: EventEmitter<PersonaClientes>;

  @Input('desgloseFacturas') desgloseFacturas: DesgloseFacturas;
  @Output('desgloseFacturasOutput') desgloseFacturasOutput: EventEmitter<DesgloseFacturas>;

  public auxJasper: AuxJasper;
  public datosenviarCorreo$ = new EventEmitter<EnviarCorreo>();
  public enviaCorreo = new EnviarCorreo();
  public respuestaF: any;
  _id_factura: number;
  public isCFDI: boolean = false;
  public facturaReferenciado: boolean = false;

  public progressBar = false;
  catCfdiTipoRelacion: CatCfdiTiposRelacion[];
  showBar() {
    this.progressBar = true;
  }
  errorTimbre: boolean = false;
  showErrorTimbre() {
    this.errorTimbre = true;
  }
  display: boolean = false;
  showDialog() {
    this.display = true;
  }
  enviaC: boolean = false;
  handleChange(e) {
    this.enviaC = e.checked;
  }

  constructor(
    private formBuilder: FormBuilder,
    private datosCfdiFacturasService: DatosCfdiFacturasService,
    private route: ActivatedRoute,

    private catCfdiUsosService: CatCfdiUsosService,
    private catMedioPagosService: CatMedioPagosService,
    private personaClientesService: PersonaClientesService,
    private desgloseFacturasService: DesgloseFacturasService,
    private buscaPersonaClientesService: BuscaPersonaClientesService,
    private catCfdiTiposRelacionService: CatCfdiTiposRelacionService,
    private jasp: JasperService, 
    private router: Router,
    private privilegiosService: PrivilegiosService
    
  ) {
    this.datosCfdiFacturasOutput = new EventEmitter(),
      this._jasperService = jasp;
  }

 async ngOnChanges() {
    this.facturaReferenciado = await this.getPrivilegios();

    this.getDatosCfdiFacturas(this.buscaCobro.id);
    this.getAllCatMedioPagos();
    this.getAllCfdiUsos();
    this.getAllTipoRelaciones();
    this.mounted();

    this.mensajeForm = this.formBuilder.group({
      mensaje_: [undefined],
    });


    this.datosCfdiFacturasForm = this.formBuilder.group({
      id: [undefined],
      folio: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      serie: [undefined],
      nombreR: [undefined],
      domicilioR: [undefined],
      rfcR: [undefined],
      fechaPago: [undefined],
      cajero: [undefined],
      // descripcion : [undefined  ],
      cfdiSchemaLocation: [undefined],
      cfdiXslt: [undefined],
      cfdiNumVersion: [undefined],
      cfdiFechaFacturacion: [undefined],
      cfdiFormaPagoSpecified: [undefined],
      cfdiCondicionesDepago: [undefined],
      cfdiMoneda: [undefined],
      cfdiTipoCambio: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cfdiTipocambioSpecified: [undefined],
      cfdiTotal: [0, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cfdiTotalLetra: [undefined],
      cfdiTipoDeComprobante: [undefined],
      cfdiMetodoPago: [undefined],
      cfdiMetodoPagoSpecified: [undefined],
      cfdiMetodoPagoClave: [undefined],
      cfdiAddenda: [undefined],
      cfdiCfdiRelacionados: [undefined],
      cfdiDescuentoSpecified: [0],
      cfdiImpuestos: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cfdiTotalPagar: [0],
      cfdiUuid: [undefined],
      cfdiComprobanteXml: [undefined],
      cfdiComprobanteXmlString: [undefined],
      cfdiQrImage: [undefined],
      cfdiQrArray: [undefined],
      cfdiPdf: [undefined],
      emisorNombre: [undefined],
      emisorRegimenFiscal: [undefined],
      emisorRfc: [undefined],
      emisorCp: [undefined],
      emisorCert: [undefined],
      emisorCertValor: [undefined],
      emisorPk: [undefined],
      emisorKeypk: [undefined],
      emisorNoCertificado: [undefined],
      emisorPacUsuario: [undefined],
      emisorPacPass: [undefined],
      receptorNombre: [undefined],
      receptorCorreo: [undefined],
      receptorResidenciafiscal: [undefined],
      receptorResidenciafiscalspecified: [undefined],
      receptorRfc: [undefined],
      receptorUsocfdi: [undefined],
    });

    if (this.datosCfdiFacturas) { this.datosCfdiFacturasForm.patchValue(this.datosCfdiFacturas); }


    this.catalogosForm = this.formBuilder.group({
      id: [undefined],
      idMedioPago: [undefined],
      uuid: [undefined],
      idTipoRelacion: [undefined],
    });

    this.datosClientesForm = this.formBuilder.group({
      id: [undefined],
      razonSocial: [undefined, [Validators.required, Validators.maxLength(100)]],
      nombre: [undefined, [Validators.required, Validators.maxLength(230)]],
      correoElectronico: [undefined, [Validators.required, Validators.maxLength(20)]],
      rfc: [undefined, [Validators.required, Validators.maxLength(20)]],
      cp:  [undefined, [Validators.required, Validators.maxLength(5)]],
      regimenFiscal: [undefined],
      idRegimenFiscal: [undefined],
      busqueda: [undefined],
    });
    if (this.personaClientes) { this.datosClientesForm.patchValue(this.personaClientes); }


    this.desgloseFacturasForm = this.formBuilder.group({
      id: [undefined],
      idCobro: [undefined],
      fechaPago: [undefined],
      claveprodserv: [undefined],
      claveunidad: [undefined],
      concepto: [undefined],
      cantidad: [undefined],
      monto: [0],
      descuento: [0],
    });
    if (this.desgloseFacturas) { this.desgloseFacturasForm.patchValue(this.desgloseFacturas); }

  }
  async f_showClientes() {
    this.buscaClientes = true;
  }

  async mounted() {
    console.log('THIS', this.datosCFDI)
  }

  async getAllCfdiUsos() {
    try {
      const datoRetorno = await this.catCfdiUsosService.getAll().toPromise();
      this.catUsoCfdi = datoRetorno;
    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por getCatUsoCfdi');
    }
  }

  async getAllCatMedioPagos() {
    try {
      const datoRetorno = await this.catMedioPagosService.getAll().toPromise();
      this.catMedioPagos = datoRetorno;
    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por getCatMedioPagos', this.catMedioPagos);
    }
  }

  async selectOPtionA() {
    let idMedioPago = this.catalogosForm.controls.idMedioPago.value;
    this.mediopago = this.catMedioPagos.find(x => x.id === idMedioPago);
    console.log('cat', this.mediopago);

  }

  async selectOptionB() {
    var id = this.catalogosForm.controls.id.value;
    this.usoCFDI = this.catUsoCfdi.find(x => x.id === id);
    console.log('cat', this.usoCFDI);
  }
  // cerr || 20250306 || se agrega metodo para cargar lo seleccionado de mi select de tipo de relacion
  async selectTipoRelacion(){
    var id = this.catalogosForm.controls.idTipoRelacion.value;
    this.tipoRelacion = this.catCfdiTipoRelacion.find(x => x.id === id);
    console.log('tipoRelacion', this.tipoRelacion);
  }

  async asignaClientes() {
    console.log('SELECTION', this.seleccion);
    
    if (this.seleccion == 'byDefault') {
      if (this.datosCFDI.rfcR) { this.personaCliente.rfc = this.datosCFDI.rfcR; }
      if (this.datosCFDI.nombreR) { this.personaCliente.nombre = this.datosCFDI.nombreR }
      if (this.datosCFDI.receptorCorreo) { this.personaCliente.correoElectronico = this.datosCFDI.receptorCorreo; }
      // if (this.datosCFDI.receptorNombre) { this.personaCliente.razonSocial = this.datosCFDI.receptorNombre; }
      if (this.datosCFDI.receptorNombre) { this.personaCliente.nombre = this.datosCFDI.receptorNombre; }
      if (this.datosCFDI.domicilioFiscal) { this.personaCliente.cp =  Number(this.datosCFDI.domicilioFiscal); }
      if (this.datosCFDI.idRegimenFiscal) {
        this.personaCliente.idRegimenFiscal = this.datosCFDI.idRegimenFiscal;
        this.personaCliente.regimenFiscal = this.datosCFDI.regimenFiscalDesc;
      }
      if (this.datosCFDI.idUsoCfdi) {this.personaCliente.idUsoCfdi = this.datosCFDI.idUsoCfdi}
      if(this.datosCFDI.idMedioPago) {this.mediopago = this.catMedioPagos.find(x => x.id === this.datosCFDI.idMedioPago)}
      this.catalogosForm.patchValue({
        idMedioPago: this.mediopago.id
      });

      this.datosClientesForm.patchValue(this.personaCliente);
    } else if (this.seleccion == 'byBusqueda') {
      this.personaCliente.rfc = this.datosClientesForm.value.rfc;
      this.personaCliente.cp = this.datosClientesForm.value.cp;
      this.personaCliente.nombre = this.datosClientesForm.value.nombre;
      this.personaCliente.correoElectronico = this.datosClientesForm.value.correoElectronico;
      this.personaCliente.razonSocial = this.datosClientesForm.value.razonSocial;
      this.personaCliente.regimenFiscal = this.datosClientesForm.value.regimenFiscal;
      this.personaCliente.idRegimenFiscal = this.datosClientesForm.value.idRegimenFiscal;
    }
    console.log('DatosPersonaClientes', this.personaCliente);
    this.buscaClientes = false;
    this.isCFDI = false;
  }

  async getPersonaClientes(datosEnvia: PersonaClientes) {
    try {
     
      // if(this.datosClientesForm.value.id == null || this.datosClientesForm.value.id == 0){
      //   this.muestraMensaje.error('Ingresa una Clave Valida', 'top', 'center'); return }
      const datoRetorno = await this.buscaPersonaClientesService
        .add(datosEnvia)
        .toPromise();
      if (datoRetorno != null) {
        console.log("TRAJO BPC", datoRetorno[0])
        this.datosClientesForm.reset();
        this.datosClientesForm.patchValue({
          // razonSocial: datoRetorno[0].razonSocial,
          // nombre: datoRetorno[0].nombreCliente,
          
          //Se unen los dos datos de nombre o razon social 
          nombre: datoRetorno[0].nombreCliente || datoRetorno[0].razonSocial,
          correoElectronico: datoRetorno[0].correoElectronico,
          rfc: datoRetorno[0].rfc,
          cp: datoRetorno[0].cp,
          regimenFiscal: datoRetorno[0].regimenFiscal,
          idRegimenFiscal: datoRetorno[0].idRegimenFiscal,
        });
        this.personaCliente = datoRetorno[0];
        console.log("datosClientesForm", this.datosClientesForm)
        this.seleccion = 'byBusqueda'
        this.asignaClientes();
        if(this.personaCliente?.idUsoCfdi){

          this.usoCFDI = null;
          this.usoCFDI = this.catUsoCfdi.find((x) => x.id === this.personaCliente.idUsoCfdi);
          this.catalogosForm.patchValue({
              id: this.personaCliente.idUsoCfdi
          });
          this.isCFDI=true;
      }
      else
          await this.getAllCfdiUsosByRegimen();
        this.muestraMensaje.notification('Registro encontrado.', 'top', 'center');
      } else {
        this.muestraMensaje.notification('No se encontró registro.', 'top', 'center');
      }
    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por getPersonaClientes');
    }

    

  }

  async f_LimpiaCasillas() {
    this.personaCliente = null;
    console.log('AHORA', this.personaCliente);
    this.datosClientesForm.reset();
  }

  async getDatosCfdiFacturas(id: number) {
    try {
      const datoRetornoCfdi = await this.datosCfdiFacturasService
        .getSingle(id)
        .toPromise();
      // tslint:disable-next-line: no-unused-expression
      await this.datosCfdiFacturasForm.patchValue(datoRetornoCfdi[0]);
      this.datosCFDI = datoRetornoCfdi[0];
      this.seleccion = 'byDefault'
      this.asignaClientes();
      if(this.personaCliente?.idUsoCfdi){

        this.usoCFDI = null;
        this.usoCFDI = this.catUsoCfdi.find((x) => x.id === this.personaCliente.idUsoCfdi);
        this.catalogosForm.patchValue({
            id: this.personaCliente.idUsoCfdi
        });
        this.isCFDI=true;
    }
    else
        await this.getAllCfdiUsosByRegimen();
      await console.log('Esto retorna el formulario', this.datosCfdiFacturasForm.value);
      await console.log('Esto retorna el get', datoRetornoCfdi);
      await this.llenaCobros();
    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por getDatosCfdiFacturas');
    }
  }


  async limpia() {
    try {
      this.DatosCobrosTable.splice(0);
      this.datosCfdiFacturasForm.reset();
      this.datosClientesForm.reset();
    } catch (e) {
      console.log(e.message);
      this.muestraMensaje.error(e.message, 'top', 'center');
    } finally {
      console.log('Paso por limpia');
    }
  }

  async Facturar(FacturacionData) {
    try {
      this.mensajeForm.patchValue({
        mensaje_: 'Realizando factura, por favor espere...'
      });

      const numero = Object.keys(this.DatosCobrosTable);
      console.log('estos es el mumero', numero);
      if (numero.length === 0)
        throw new Error('Seleccione un pago a facturar.');

      FacturacionData = {
        id: this.buscaCobro.id,
        metodoPago: this.mediopago,
        usoCFDI: this.usoCFDI,
        receptor: this.personaCliente,
        
      }
      if(this.catalogosForm.value.uuid){	
        FacturacionData.uuid = this.catalogosForm.value.uuid;
      }
      if(this.tipoRelacion){
        FacturacionData.tipoRelacion = this.tipoRelacion.codigo;
      }
      await console.log('Medio pago= ', this.mediopago, ' Usocfdi= ', this.usoCFDI.clave)


      if (this.mediopago.id == null)
        throw new Error("Debe seleccionar un Método de Pago.");
      if (this.usoCFDI.id == null)
        throw new Error("Debe seleccionar el uso del CFDI.");

      if(this.personaCliente.regimenFiscal == null )
        throw new Error("Indique el régimen fiscal correspondiente del receptor.");
      
      if(this.personaCliente.cp == null )
        throw new Error("Indique el domicilio fiscal correspondiente del receptor.");

      // ===========================================
      //                     FACTURAR
      // ==========================================

      console.log('ESTO SE ENVIA', FacturacionData);

      this.showBar();
      const datoretorno = await this.datosCfdiFacturasService
        .add(FacturacionData)
        .toPromise();
      this.datosCfdiFacturas = datoretorno;
      console.log('Esto retorna api facturacion---->', datoretorno);

      if (datoretorno) {
        this.progressBar = false;
        this.respuestaF = datoretorno;

        console.log('ESTATUS:', this.respuestaF.estatus);
        if (this.respuestaF.estatus != 'OK') {
          this.mensajeForm.patchValue({
            mensaje_: this.respuestaF.estatus + '\n \n \n ¿INTENTAR TIMBRAR EL PAGO DE NUEVO?'
          });
          this.showErrorTimbre();
        } else {
          await this.imprimeComprobante(
            this.respuestaF.idFactura,
            this.respuestaF.tipoRecibo
          );
          this.limpiaForm();
        }

        this._id_factura = this.respuestaF.idFactura;
        this.enviaCorreo.idFactura = this._id_factura;
        await this.enviarCorreo();

        // await this.imprimeComprobante(datoretorno[0].idFactura, datoretorno[0].tipoRecibo);
      }

      

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
      this.progressBar = false;
    } finally {
      console.log('Paso por addDatosCfdiFacturas');
    }
  }

  limpiaForm() {
    this.datosClientesForm.reset();
    this.catalogosForm.reset();
  }

  async imprimeComprobante(id_Factura, reporte) {
    try {
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.tipo = "pdf";
      // if (reporte === 1) {
        this.auxJasper.JasperReport.nombreReporte = "001_Factura";
      
      console.log("Tipo de Comprobante: ", reporte);
      // -- Parametros --
      const id_factura = new ParametroJasper();
      id_factura.nombre = "_id_factura";
      id_factura.valor = id_Factura + "";
      console.log("Parametro:", id_factura.nombre, "Valor:", id_factura.valor);
      let reimpresion = new ParametroJasper();
      reimpresion.nombre = 'reimpresion';
      reimpresion.valor = false + "";
      let timbre = new ParametroJasper();
      timbre.nombre = 'timbre';

      debugger;
      if (reporte === 1) 
          timbre.valor = true + "";
      else
          timbre.valor = false + "";
      
      await this.auxJasper.ParametroJasper.push(reimpresion);
      await this.auxJasper.ParametroJasper.push(timbre);
      await this.auxJasper.ParametroJasper.push(id_factura);

      console.log("Agui va");
      await this.showDialog();

    } catch (e) {
      this.progressBar = false;
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por imprimeComprobante");
    }
  }

  async llenaCobros() {
    // Carga la tabla con buscaCobro que se la paso facturacion
    try {
      if (this.DatosCobrosTable.values) {
        await this.DatosCobrosTable.splice(0);
      }
      await this.DatosCobrosTable.push(this.buscaCobro);
      // console.log('---->',   this.DatosCobrosTable);

    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log('Paso por addDatosCfdiFacturas');
    }
  }


  async childPersonaClientes(personaClientes: PersonaClientes) {
   // console.log("TRAJO PC", personaClientes);
    const personaClientesB = new PersonaClientes();
    personaClientesB.id = personaClientes.id;
    this.getPersonaClientes(personaClientesB);

  }
  async enviarCorreo() {
    try {

      const datosenviarCorreo = new EnviarCorreo();
      datosenviarCorreo.idFactura = this._id_factura;
      datosenviarCorreo.correo = this.enviaCorreo.correo;
      datosenviarCorreo.correocopia = "";
      // console.log('ESTO DEBE EMITIR', datosenviarCorreo);
      await this.datosenviarCorreo$.emit(datosenviarCorreo);

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por enviarCorreo");
    }
  }
  async confirm() {
    this.errorTimbre = false;
    await this.Facturar(this.facturacionData);
  }

  async cancelar() {
    this.errorTimbre = false;
    await this.imprimeComprobante(
      this.respuestaF.idFactura,
      this.respuestaF.tipoRecibo
    );
  }




  cancel() {
    //console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');

  }
  async getAllCfdiUsosByRegimen() {
    try {
      debugger;
        if (this.personaCliente) {
            const datoRetorno = await this.catCfdiUsosService.getByRegimen((this.personaCliente.idRegimenFiscal ? this.personaCliente.idRegimenFiscal : 12)).toPromise();
            if (datoRetorno) {
                this.catUsoCfdi = null;
                this.catUsoCfdi = datoRetorno;
                if(!this.isCFDI){
                    // ASIGNA EL PRIMER CFDI
                    this.usoCFDI = this.catUsoCfdi[0];
                    this.catalogosForm.patchValue({
                        id: this.usoCFDI.id
                    });
                }
            }
        }
    } catch (e) {
        if (e.response) {
            throw { message: e.response.data };
        } else {
            throw e;
        }
    } finally {
        console.log("Paso por getCatUsoCfdi");
    }
  }
  // cerr || 20250220 || se agrega metodo para cargar catalogo para las relaciones del sat cuando es una factura relacionada
  async getAllTipoRelaciones() {
    try {
      const datoRetorno = await this.catCfdiTiposRelacionService.getAll().toPromise();
      this.catCfdiTipoRelacion = datoRetorno;
    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por getCatUsoCfdi');
    }
  }	
   async getPrivilegios() {
          try {
            let objUrl = new Privilegios();
            objUrl.uuid = 'ef285c70-3c71-49a9-bc88-01b55923c4fe';
            let conPrivilegio = await this.privilegiosService.GetPrivilegioByUUID(objUrl).toPromise();
            return conPrivilegio;
            console.log('privilegios', conPrivilegio)
          } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
          } finally {
            console.log("Paso por getPrivilegios");
          }
        }
}
